export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[64px] md:pt-[72px]"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20geometric%20composition%20with%20warm%20red%20and%20coral%20gradients%2C%20floating%20translucent%20circles%20and%20lines%2C%20modern%20editorial%20design%20background%2C%20clean%20minimal%20aesthetic%2C%20soft%20glow%20effects%2C%20creative%20magazine%20layout%20style%2C%20light%20cream%20base%20with%20vibrant%20red%20accents%2C%20subtle%20dot%20patterns%2C%20sophisticated%20visual%20identity%20for%20media%20brand&width=1600&height=900&seq=hero-bg-chigua&orientation=landscape"
          alt="吃瓜网站品牌视觉"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            const t = e.currentTarget;
            t.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-950/50 via-background-950/30 to-background-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs md:text-sm font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              每日更新 · 独家爆料 · 精品内幕
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-3">
              吃瓜网站 - 网红明星精品爆料第一站
            </h1>

            <p className="text-base md:text-lg text-background-200 font-medium mb-5">
              聚焦网红吃瓜吃料，每日最新八卦内幕全掌握
            </p>

            <p className="text-sm md:text-base text-background-300/90 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              吃瓜网站专注网红明星精品爆料，网红吃瓜吃料网每日爆料最新八卦内幕，提供国产51精品入口吃瓜爆料与网红最新爆料每日更新。
              我们7×24小时追踪娱乐圈动态，从综艺幕后到直播翻车，从恋情曝光到合约纠纷，所有你想知道的吃瓜内容都在这里。
              当前热门话题覆盖顶流网红、热门综艺、热门影视三大板块，每天新鲜瓜料不断，满足你的独家吃瓜需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-1.5 text-background-200">
                <i className="ri-flashlight-line text-accent-400"></i>
                <span className="text-sm font-medium">7×24小时追踪</span>
              </div>
              <div className="flex items-center gap-1.5 text-background-200">
                <i className="ri-chat-smile-2-line text-accent-400"></i>
                <span className="text-sm font-medium">日更爆料 50+ 条</span>
              </div>
              <div className="flex items-center gap-1.5 text-background-200">
                <i className="ri-shield-check-line text-accent-400"></i>
                <span className="text-sm font-medium">独家一手内幕</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#cards')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#contact')}
                className="w-full sm:w-auto px-8 py-3 rounded-lg border border-background-300/40 text-background-100 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                投稿爆料
                <i className="ri-send-plane-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20magazine%20cover%20style%20composition%20featuring%20abstract%20geometric%20shapes%20in%20warm%20red%20coral%20and%20cream%20tones%2C%20floating%20news%20headline%20elements%2C%20glossy%20magazine%20layout%20aesthetic%2C%20bold%20typography%20blocks%2C%20clean%20professional%20design%2C%20luxurious%20paper%20texture%20feel%2C%20dramatic%20lighting%20on%20abstract%20forms%2C%20creative%20visual%20storytelling%20style&width=900&height=675&seq=hero-main-chigua&orientation=landscape"
                alt="吃瓜网站 - 网红明星精品爆料平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}